import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';
import EditIcon from '../Icons/EditIcon';
import CompletedIcon from '../Icons/CompletedIcon';
import ContinueIcon from '../Icons/ContinueIcon';
import TestItemStatus from '../TestItemStatus';

import cl from 'classnames';
import s from './TestItemIcon.css';

class TestItemIcon extends Component {
  render() {
    const {
      iconLabel,
      isActive,
      isLocked,
      className,
      size,
      status,
      avatarStyle,
      letterStyle,
      avatarContainerStyle,
      isCompleted,
    } = this.props;

    return (
      <div style={avatarContainerStyle} className={s.TestItemIcon}>
        <Avatar
          className={cl(className)}
          string={iconLabel}
          size={size}
          letterStyle={letterStyle}
          style={avatarStyle}
          letterClassName={cl(
            s.Letter,
            isActive && s.ItemActive,
            isLocked && s.ItemLocked,
            s.CustomLetter
          )}
          outerClassName={
            isCompleted
              ? cl(s.ItemAvatar, s.ItemAvatarCompleted)
              : cl(s.ItemAvatar, isActive && s.ItemActive, isLocked && s.ItemLocked)
          }
        />
        {status === 'incomplete' ? (
          <TestItemStatus size={22} icon={<ContinueIcon />} className={s.StatusIcon} />
        ) : null}
        {/* {status === 'complete' ? (
          <TestItemStatus size={28} icon={<EditIcon />} className={s.StatusIcon} />
        ) : null} */}
        {status === 'complete' ? (
          <TestItemStatus size={26} icon={<CompletedIcon />} className={s.StatusIcon} />
        ) : null}
      </div>
    );
  }
}

TestItemIcon.propTypes = {
  iconLabel: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  size: PropTypes.number,
  status: PropTypes.string,
};

export default TestItemIcon;
